import * as AES from 'crypto-js/aes';
import * as encUtf8 from 'crypto-js/enc-utf8';
import SHA1 from 'crypto-js/sha1';

const key = 'df15!1s631Afv1+s';

export function hash(text: string): string {
  return SHA1(text).toString();
}

export function encrypt(text: string): string {
  return AES.encrypt(text, key).toString();
}

export function decrypt(crypted: string): string {
  return AES.decrypt(crypted, key).toString(encUtf8);
}
